module.exports = __webpack_public_path__ + "img/bruselas.317d3bab.png";